'use client';

import clsx from 'clsx';
import React from 'react';
import secondaryHeaderStyles from './secondary-header.module.scss';
import { SecondaryNav } from './secondary-nav/secondary-nav';
import { UserLocation } from './user-location/user-location';

export const SecondaryHeader = (): React.JSX.Element => {
  return (
    <nav className="flex items-center justify-center bg-(--background) md:h-8">
      <div className={clsx('flex flex-auto items-center justify-between container-xl', secondaryHeaderStyles['secondary-header'])}>
        <UserLocation />
        <SecondaryNav />
      </div>
    </nav>
  );
};
